import SystemCustomDivider from "./SystemCustomDivider";

export default function SystemExerciserWarningDivider() {
    // Used through the app to announce a section with
    // a textual divider

    // BUILD
    return (
        <div className={"w-full flex items-center mt-[8px]"}>
            <SystemCustomDivider color={"bg-greyLight3"} />
            <span className={"font-normal text-[12px] sm:text-[14px] text-greyLight5 px-12 leading-none mb-2 sm:mb-4"}>
                {"Consigne"}
            </span>
            <SystemCustomDivider color={"bg-greyLight3"} />
        </div>
    );
}